// extracted by mini-css-extract-plugin
module.exports = {"container":"_1TnqmplOawb1fRcztbtxhy","groupsList":"_3DZqb9s47NCV86p1wvyWxG"};